import { defineStrings, useStrings } from "../i18n";

const strings = defineStrings({ loading: "Loading" }, { loading: "Chargement" });

/** Placeholder lines while content arrives. One status for the whole block. */
export function Skeleton(props: { lines?: number; label?: string }) {
  const t = useStrings(strings);
  const lines = Math.max(1, Math.min(8, props.lines ?? 3));
  return (
    <div className="ui-skeleton" role="status" aria-label={props.label ?? t("loading")}>
      {Array.from({ length: lines }, (_, i) => (
        <span key={i} className="ui-skeleton__line" />
      ))}
    </div>
  );
}
